import SearchDialog from './SearchDialog';

export default { 
  name: "search", 
  component: SearchDialog, 
  fullScreen: false
};